import React from "react";
import { Box, Button, Typography, Dialog, DialogContent } from "@mui/material";
import DeleteIcon from "../assets/images/Delete.svg";

export default function DeleteEventPopup({
  open,
  handleClose,
  handleConfirm,
  contentRetention,
}) {
  return (
    <Box>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: "34px", // Apply 100px border radius to the dialog box
            overflow: "hidden", // Ensure content stays within rounded corners
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "21px 35px",
            display: "flex", // Use flexbox
            flexDirection: "column", // Stack items vertically
            alignItems: "center",
          }}
        >
          {/* Icon Box */}
          <Box
            sx={{
              width: "70px",
              height: "70px",
              borderRadius: "50%",
              backgroundColor: "#F1F7FA",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: "16px", // Add spacing below the icon
            }}
          >
            <img src={DeleteIcon} />
          </Box>

          {/* Title */}
          <Typography
            color="#2A4876"
            variant="h6"
            fontWeight="bold"
            gutterBottom
          >
            {contentRetention ? (
              "Are You Sure?"
            ) : (
              <>
                Are you sure you want to <br /> delete this event?
              </>
            )}
          </Typography>
          {contentRetention && (
            <Typography>
              Once you delete all content, it cannot be recovered.
            </Typography>
          )}

          {/* Buttons */}
          <Box mt={3} display="flex" justifyContent="center" gap={2}>
            <Button
              onClick={handleConfirm} // Confirms logout
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#AAB6C8",
                color: "#2A4876",
                fontWeight: "bold",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#C4CED8" },
              }}
            >
              Yes
            </Button>
            <Button
              onClick={handleClose} // Closes the popup
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#2A4876",
                color: "#FFFFFF",
                fontWeight: "bold",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#002A5C" },
              }}
            >
              No
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
